'use strict';

import cf7Helpers from '../../../src/js/shared/cf7Helpers';
import Select2 from '../../../src/js/shared/select2';

const $ = jQuery.noConflict();
$(function() {

	const contactForm = {

		inquiryLabels: {
			sponsor: 'I\'d like to become a sponsor',
			suggestion: 'I have a suggestion',
			donate: 'I want to donate',
			general: 'General inquiry',
			order: 'Question about my order',
			wholesale: 'Wholesale / schools / camps',
		},

		init: function() {
			this.cacheDOM();
			if (!this.$select.length) {
				return;
			}

			// Apply selection BEFORE Select2 init
			this.applyInquirySelection();

			this.initSelect2();

			// Apply again AFTER Select2 init
			this.applyInquirySelection();

			// Set up persistent re-application
			this.setupPersistentSelection();

			cf7Helpers.afterFormSubmit();
			cf7Helpers.resetSelect2OnSubmit('.js-contact-select');
			cf7Helpers.preventNumTelInputsTypeLetters();
		},

		cacheDOM: function() {
			this.$select = $('.js-contact-select');
		},

		initSelect2: function() {
			Select2.initializeSelect2('.js-contact-select', {
				width: '100%',
				dropdownParent: this.$select.closest('.contact-block__form-wrap'),
				placeholder: 'Select type of inquiry*'
			});
		},

		getInquiryParam: function() {
			return (new URLSearchParams(window.location.search).get('inquiry') || '').toLowerCase().trim();
		},

		normalize: function(value) {
			return String(value || '')
				.toLowerCase()
				.replace(/[\u2018\u2019']/g, '')
				.trim();
		},

		findMatchingOption: function(selectEl, inquiry) {
			const label = this.inquiryLabels[inquiry] || '';
			const needles = [...new Set([
				this.normalize(inquiry),
				this.normalize(label),
			])].filter(Boolean);

			const options = Array.from(selectEl.options);

			for (let i = 0; i < options.length; i++) {
				const option = options[i];
				if (!option.value && option.value !== '0') {
					continue;
				}

				const value = this.normalize(option.value);
				const text = this.normalize(option.text);

				for (const needle of needles) {
					if (value === needle || text === needle || value.includes(needle) || text.includes(needle)) {
						return {option, index: i};
					}
				}
			}

			return null;
		},

		applyInquirySelection: function() {
			const inquiry = this.getInquiryParam();
			if (!inquiry) {
				return false;
			}

			let applied = false;

			this.$select.each((_, selectEl) => {
				const match = this.findMatchingOption(selectEl, inquiry);
				if (!match) {
					return;
				}

				const {option, index} = match;
				const $select = $(selectEl);

				// Clear all selections first
				Array.from(selectEl.options).forEach((opt, i) => {
					opt.selected = i === index;
				});

				// Set native properties
				selectEl.selectedIndex = index;
				selectEl.value = option.value;

				// Set jQuery val
				$select.val(option.value);

				// Trigger Select2 update if initialized
				if ($select.hasClass('select2-hidden-accessible')) {
					$select.trigger('change.select2');
				}

				// Trigger standard change
				$select.trigger('change');

				// Dispatch native events
				selectEl.dispatchEvent(new Event('input', {bubbles: true}));
				selectEl.dispatchEvent(new Event('change', {bubbles: true}));

				applied = selectEl.value === option.value;
			});

			return applied;
		},

		setupPersistentSelection: function() {
			const inquiry = this.getInquiryParam();
			if (!inquiry) {
				return;
			}

			let attempts = 0;
			const maxAttempts = 20;

			const ensureSelection = () => {
				attempts++;

				const selectEl = this.$select.get(0);
				if (!selectEl) {
					return;
				}

				const match = this.findMatchingOption(selectEl, inquiry);
				if (!match) {
					if (attempts < maxAttempts) {
						setTimeout(ensureSelection, 100);
					}
					return;
				}

				// Check if already correctly selected
				if (selectEl.value === match.option.value && selectEl.value !== '') {
					return;
				}

				// Apply selection
				this.applyInquirySelection();

				// Keep trying until stable
				if (attempts < maxAttempts) {
					setTimeout(ensureSelection, 100);
				}
			};

			// Multiple trigger points
			$(window).on('load', () => this.applyInquirySelection());
			document.addEventListener('wpcf7init', () => this.applyInquirySelection());

			// Polling for race conditions
			setTimeout(ensureSelection, 0);
			setTimeout(ensureSelection, 50);
			setTimeout(ensureSelection, 150);
			setTimeout(ensureSelection, 300);
			setTimeout(ensureSelection, 500);
			setTimeout(ensureSelection, 1000);

			// requestAnimationFrame for next paint
			requestAnimationFrame(() => this.applyInquirySelection());
		}
	};

	contactForm.init();
});
